import Search from "./search.component";

export default angular
    .module("oui.search", [])
    .component("ouiSearch", Search)
    .name;
